import Checkbox from '@creditflowresearch/uilib/Checkbox';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import useRankingsSection from './useRankingsSection';

import styles from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/checkboxFilter.module.scss';

const Rankings = () => {
  const { items, selectedValues, isAllSelected, isIndeterminate, toggle, toggleAll } = useRankingsSection();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Rankings }
      header={ (
        <FilterSectionHeader
          title="RANKING"
          leftSlot={ (
            <Checkbox
              checked={ isAllSelected }
              onChange={ toggleAll }
              indeterminate={ isIndeterminate }
              supportIndeterminate
              dataTest="rankingsFiltersAllCheckbox"
            />
          ) }
        />
      ) }
    >
      <div className={ styles.columns2 }>
        { items.map((item) => (
          <FilterItem key={ item.value } isExpandable={ false }>
            <Checkbox
              label={ item.name }
              checked={ selectedValues.includes(item.value) }
              onChange={ () => toggle(item.value) }
              dataTest={ `checkbox-ranking-${ item.value }` }
            />
          </FilterItem>
        )) }
      </div>
    </FilterSection>
  );
};

export default Rankings;
